import React, { useEffect, useState } from "react";
import { Text } from "@fluentui/react-components";
import {
    Flex,
    Table,
    tableHeaderCellBehavior,
} from "@fluentui/react-northstar";
import {
    ArrowSortDown16Filled,
    ArrowSortUp16Filled,
} from "@fluentui/react-icons";
import ModalDetailTask from "./ModalDetailTask";
import TaskRow from "./TaskRow";
import {
    _api_validate_document,
    _get_collaborator_tasks,
    _update_status_task,
} from "../../api/tasks";
import { DialogStyle, TableLabel } from "./style";
import { useQuery } from "react-query";
import LoaderPage from "../../components/loaders/LoaderPage";
import ModalDetailTaskWithoutActions from "./ModalDetailTaskWithoutActions";
import {
    BADGE_STATUS_TASKS,
    SORT_BY_STATUS,
    TASK_STATUS,
} from "../../constants/tasks";
import Toast from "../../components/Alerts";
import DialogDetailTask from "./DialogDetailTask";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import { DEVICE } from "../../constants/responsive";
import { ROUTES } from "../../constants/routes";
import styled from "styled-components";

const ArrowSortDown = (
    <ArrowSortDown16Filled style={{ color: "var(--color-primary)" }} />
);
const ArrowSortUp = (
    <ArrowSortUp16Filled style={{ color: "var(--color-primary)" }} />
);

const ViewTable = ({
    tasksProps = null,
    isPageOnboarding = false,
    user,
    activeTab,
    AgencyId,
    isFetchingUserDetail,
    isPageOffboarding,
}) => {
    const location = useLocation();

    const [toast, setToast] = useState({
        visible: false,
        content: "",
        level: "success",
    });

    useEffect(() => {
        const location_state_message = location.state?.message;
        if (location_state_message) {
            setToast({
                visible: true,
                content: location.state?.message,
                level: "success",
            });
            return;
        }
    }, []);

    const [sorted, setSorted] = useState({
        due_date: 0, // 0 asc - 1 desc
        status: 0,
    });
    const [tasks, setTasks] = useState(null);

    useEffect(() => {
        setTasks(tasksProps);
    }, [tasksProps]);

    const {
        isLoading,
        isFetching,
        refetch: refetchGetAllTasksForTable,
        data: tasksData,
    } = useQuery(["getAllTasksForTable"], () => _get_collaborator_tasks(), {
        refetchOnWindowFocus: false,
        enabled: !tasksProps,
        // onSuccess: (data) => {
        //     return setTasks(data);
        // },
    });

    const _sort_by_due_date = () => {
        if (!sorted.due_date) {
            const sorted_tasks = tasks?.tasks?.sort((a, b) => {
                return moment(a.due_date) - moment(b.due_date);
            });
            setTasks((state) => ({
                ...state,
                tasks: sorted_tasks,
            }));
            setSorted((state) => ({
                ...state,
                due_date: 1,
            }));
        } else {
            const sorted_tasks = tasks?.tasks?.sort(
                (a, b) => moment(b.due_date) - moment(a.due_date)
            );
            setTasks((state) => ({
                ...state,
                tasks: sorted_tasks,
            }));
            setSorted((state) => ({
                ...state,
                due_date: 0,
            }));
        }
        return;
    };

    const _sort_by_status = () => {
        if (!sorted?.status) {
            const sorted_tasks = tasks?.tasks?.sort(
                (a, b) => SORT_BY_STATUS[a.status] - SORT_BY_STATUS[b.status]
            );
            setTasks((state) => ({
                ...state,
                tasks: sorted_tasks,
            }));
            setSorted((state) => ({
                ...state,
                status: 1,
            }));
        } else {
            const sorted_tasks = tasks?.tasks?.sort(
                (a, b) => SORT_BY_STATUS[b.status] - SORT_BY_STATUS[a.status]
            );
            setTasks((state) => ({
                ...state,
                tasks: sorted_tasks,
            }));
            setSorted((state) => ({
                ...state,
                status: 0,
            }));
        }
        return;
    };

    return (
        <>
            <Toast
                key="Task_toast"
                visible={toast.visible}
                content={toast.content}
                level={toast.level}
                onStatusChange={(e) => {
                    location.state = {};
                    return setToast({
                        visible: false,
                        content: "",
                        level: "warning",
                    });
                }}
            />
            <Flex
                fill
                styles={{
                    overflowX: "scroll",

                    width: "100%",
                }}
            >
                {isLoading || isFetching || isFetchingUserDetail ? (
                    <LoaderPage label="Chargement des tâches" />
                ) : (
                    <TableStyle aria-label="table">
                        {/* Head */}
                        <Table.Row header>
                            <Table.Cell
                                content={
                                    <Flex
                                        onClick={_sort_by_due_date}
                                        gap="gap.smaller"
                                        vAlign="center"
                                        styles={{ cursor: "pointer" }}
                                    >
                                        <TableLabel weight="regular">
                                            Échéance
                                        </TableLabel>
                                        {!sorted.due_date
                                            ? ArrowSortDown
                                            : ArrowSortUp}
                                    </Flex>
                                }
                                accessibility={tableHeaderCellBehavior}
                                style={{ maxWidth: "126px" }}
                            />
                            <Table.Cell
                                content={
                                    <Flex
                                        gap="gap.smaller"
                                        vAlign="center"
                                        styles={{ cursor: "pointer" }}
                                        onClick={_sort_by_status}
                                    >
                                        <Text weight="regular">Statut</Text>
                                        {!sorted.status
                                            ? ArrowSortDown
                                            : ArrowSortUp}
                                    </Flex>
                                }
                                accessibility={tableHeaderCellBehavior}
                                style={{ maxWidth: "106px" }}
                            />
                            <Table.Cell
                                content={
                                    <Flex gap="gap.smaller" vAlign="center">
                                        <Text weight="regular">À faire</Text>
                                    </Flex>
                                }
                                accessibility={tableHeaderCellBehavior}
                                style={{ maxWidth: "160px" }}
                            />
                            <Table.Cell
                                content={
                                    <Flex gap="gap.smaller" vAlign="center">
                                        <TableLabel
                                            bolder
                                            content="Nom de la tâche"
                                        />
                                    </Flex>
                                }
                                accessibility={tableHeaderCellBehavior}
                                style={{ flex: 1 }}
                            />

                            <Table.Cell
                                content={
                                    <Flex gap="gap.smaller" vAlign="center">
                                        <Text weight="regular">Catégorie</Text>
                                    </Flex>
                                }
                                accessibility={tableHeaderCellBehavior}
                                style={{ maxWidth: "200px" }}
                            />
                            <Table.Cell
                                content={
                                    <Flex gap="gap.smaller" vAlign="center">
                                        <Text weight="regular">
                                            À faire par
                                        </Text>
                                    </Flex>
                                }
                                accessibility={tableHeaderCellBehavior}
                                style={{ maxWidth: "200px" }}
                            />
                        </Table.Row>
                        {/* tasks row */}
                        <Flex
                            styles={{
                                overflowY: "scroll",
                            }}
                            column
                        >
                            {tasks?.tasks?.map((el, i) => {
                                return (
                                    <div key={i}>
                                        <Link
                                            to={`/tasks/${el?.id}/user/${el?.assigned_to_user?.id}/detail`}
                                            state={{
                                                referrer:
                                                    isPageOnboarding ||
                                                    isPageOffboarding
                                                        ? location.pathname
                                                        : "/tasks",
                                                breadcrumb:
                                                    isPageOnboarding === null
                                                        ? ""
                                                        : isPageOnboarding
                                                        ? "onboarding"
                                                        : "offboarding",
                                                isHrPage:
                                                    isPageOnboarding ||
                                                    isPageOffboarding,
                                                user,
                                                activeTab,
                                                AgencyId,
                                            }}
                                            style={{
                                                textDecoration: "none",
                                            }}
                                        >
                                            <TaskRow data={el} />
                                        </Link>
                                    </div>
                                );
                            })}
                        </Flex>
                    </TableStyle>
                )}
            </Flex>
        </>
    );
};

export default ViewTable;

const TableStyle = styled(Table)`
    margin-left: 0px;
    /* height: calc(100dvh - 200px); */

    @media ${DEVICE.mobileS} {
        padding-inline: 12px;
    }
    @media ${DEVICE.tablet} {
        padding-inline: 32px;
        width: 100%;
    }
`;
